import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
document.addEventListener('DOMContentLoaded', () => {
    const twlsSection = document.querySelectorAll('.testimonial-with-logo-section');

    twlsSection.forEach(section => {
        const twlsThumbSlider = section.querySelector('.twls-logo-slider');
        const twlsMainSlider = section.querySelector('.twls-main-slider');

        const logoSlides = twlsThumbSlider.querySelectorAll('.swiper-slide');
        const totalLogoSlides = logoSlides.length;

        // Calculate which slide to center based on how many logos exist
        let startIndex = 0;
        if (totalLogoSlides === 2) {
            startIndex = 0;
        } else if (totalLogoSlides === 3 || totalLogoSlides === 4) {
            startIndex = 1;
        } else if (totalLogoSlides >= 5) {
            // Responsive logic ONLY for this case
            if (window.innerWidth < 992) {
                startIndex = 1; // On mobile, center slide differently
            } else {
                startIndex = 2; // Default for desktop
            }
        }

        // Initialize the logo (thumb) slider
        const maintlThumbSlider = new Swiper(twlsThumbSlider, {
            slidesPerView: 'auto',
            centeredSlides: true,
            spaceBetween: 48,
            initialSlide: startIndex,
            slideToClickedSlide: true,
            breakpoints: {
                576: {
                    slidesPerView: 3,
                },
                992: {
                    slidesPerView: 4,
                },
                1200: {
                    slidesPerView: 5,
                },
            },
        });

        // Initialize the main slider
        const mainSliderOptions = {
            slidesPerView: 1,
            spaceBetween: 16,
            centeredSlides: true,
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            initialSlide: startIndex,
            allowTouchMove: false,
            navigation: {
                prevEl: section.querySelector('.twls-arrow-prev'),
                nextEl: section.querySelector('.twls-arrow-next'),
            },
        };

        // if (window.innerWidth >= 576) {
        //     mainSliderOptions.thumbs = {
        //         swiper: maintlThumbSlider,
        //     };
        // }

        const maintwlsMainSlider = new Swiper(twlsMainSlider, mainSliderOptions);

        // On mobile, sync main slider with thumb slider on slide change
        if (window.innerWidth < 576) { // Mobile breakpoint
            maintlThumbSlider.on('slideChange', () => {
                maintwlsMainSlider.slideTo(maintlThumbSlider.activeIndex);
            });
        }

        maintwlsMainSlider.on('slideChangeTransitionStart', function() {
            maintlThumbSlider.slideTo(maintwlsMainSlider.activeIndex);
        });

        maintlThumbSlider.on('transitionStart', function() {
            maintwlsMainSlider.slideTo(maintlThumbSlider.activeIndex);
        });

        // Trigger init manually
        maintlThumbSlider.init();
    });
});
